import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-send-01',
  imports: [],
  templateUrl: './send-01.html',
  styleUrl: './send-01.scss',
})
export class Send01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
